type DismissalListener = (dismissed: boolean) => void;

const groups = new Map<string | number, Set<DismissalListener>>();

/** Shares visibility permission between linked tooltips while Recharts synchronizes their data. */
export function registerTooltipDismissal(
  onChange: DismissalListener,
  syncId?: string | number
) {
  const listeners =
    syncId == null
      ? new Set<DismissalListener>()
      : (groups.get(syncId) ?? new Set<DismissalListener>());
  listeners.add(onChange);
  if (syncId != null) groups.set(syncId, listeners);

  return {
    update: (dismissed: boolean) =>
      listeners.forEach((listener) => listener(dismissed)),
    dispose: () => {
      listeners.delete(onChange);
      if (syncId != null && listeners.size === 0) groups.delete(syncId);
    },
  };
}
